import LaunchIcon from "@mui/icons-material/Launch";
import { Button } from "@platform/design-system";
import { MutationObserverResult } from "@tanstack/react-query";

type GenerateRFPButtonProps = {
  onGenerateClick: VoidFunction;
  onOpenSharePointClick: VoidFunction;
} & Pick<MutationObserverResult<unknown, Error, unknown>, "status" | "error">;

export const GenerateRFPButton = ({
  status,
  onGenerateClick,
  onOpenSharePointClick,
}: GenerateRFPButtonProps): React.JSX.Element => {
  if (status === "pending") {
    return (
      <Button variant="primary" loading loadingPosition="start">
        GENERATING
      </Button>
    );
  }

  if (status === "success") {
    return (
      <Button
        variant="primary"
        onClick={onOpenSharePointClick}
        startIcon={<LaunchIcon />}
      >
        OPEN RFP TEMPLATE
      </Button>
    );
  }

  return (
    <Button
      data-testid="generate-rfp-template"
      variant="primary"
      onClick={onGenerateClick}
    >
      GENERATE RFP TEMPLATE
    </Button>
  );
};

export default GenerateRFPButton;
